import React, { ErrorInfo } from 'react';

interface ChartErrorBoundaryProps {
    children: React.ReactNode;
    fallback: React.ReactNode;
    resetKey: string;
    onError?: (error: Error, info: ErrorInfo) => void;
}

interface ChartErrorBoundaryState {
    hasError: boolean;
}

class ChartErrorBoundary extends React.Component<ChartErrorBoundaryProps, ChartErrorBoundaryState> {
    constructor(props: ChartErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(): ChartErrorBoundaryState {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        this.props.onError?.(error, info);
    }

    componentDidUpdate(prevProps: ChartErrorBoundaryProps) {
        if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
            // eslint-disable-next-line react/no-did-update-set-state -- guarded error-boundary reset: only fires when resetKey changes while in the error state, so it cannot loop
            this.setState({ hasError: false });
        }
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback;
        }

        return this.props.children;
    }
}

export default ChartErrorBoundary;
